import conf from './conf'
import axios from 'axios'

/**
 * @file ログ制御クラス
 * @namespace rahmen
 */
/**
 * @module Logger
 */
export default class {
  /**
   * デバッグレベルのログ送信
   * @param {String} message ログメッセージ
   * @param {Object} json ログオブジェクト
   */
  debug (message, json) {
    this._log(message, json, conf.logLevel.debug)
  }

  /**
  * インフォメーションレベルのログ送信
  * @param {String} message ログメッセージ
  * @param {Object} json ログオブジェクト
  */
  info (message, json) {
    this._log(message, json, conf.logLevel.info)
  }

  /**
  * 警告レベルのログ送信
  * @param {String} message ログメッセージ
  * @param {Object} json ログオブジェクト
  */
  warn (message, json) {
    this._log(message, json, conf.logLevel.warn)
  }

  /**
  * エラーレベルのログ送信
  * @param {String} message ログメッセージ
  * @param {Object} json ログオブジェクト
  */
  error (message, json) {
    this._log(message, json, conf.logLevel.error)
  }

  /**
   * ログ送信処理
   * @param {String} message ログメッセージ
   * @param {Object} json ログオブジェクト
   * @param {Number} logLevel ログレベル
   * @private
   */
  _log (message, json, logLevel) {
    if (conf.minLogLevel > logLevel) { return }
    let key = ''
    for (key in conf.logLevel) {
      if (conf.logLevel[key] === logLevel) { break }
      key = undefined
    }

    if (key === undefined) { return }
    if (conf.enableConsole && console[key]) { console[key](message, json) }

    const log = {
      timestamp: new Date(),
      logLevel: logLevel,
      message: message,
      values: JSON.stringify(json)
      // authorizedToken: this.authorizedToken,
      // userName: this.userName
    }

    this._post(log)
  }

  /**
   * ログPOST
   * @param {Object} log 送信対象
   * @private
   */
  _post (log) {
    const httpClient = axios.create({
      withCredentials: true,
      'Content-Type': 'application/json'
    })

    this._readAllLogs().then((logs) => {
      if (logs === undefined) { logs = [] }
      logs.push(log)

      var strJsons = logs.map(l => {
        return JSON.stringify(l)
      })

      httpClient({
        method: 'post',
        url: conf.logPostUrl,
        data: { formData: JSON.stringify(strJsons) }
      }).then(() => {
        this._updateLogs([])
      }).catch(() => {
        console.error('ログが送信できませんでした。indexedDBに保存されます。', logs)
        this._updateLogs(logs)
      })
    })
  }

  /**
   * indexedDBに保存されたログを取得する
   * @private
   */
  _readAllLogs () {
    return new Promise((resolve) => {
      const openReq = indexedDB.open(conf.defaultDBName)
      openReq.onsuccess = (event) => {
        const db = event.target.result
        const trans = db.transaction(conf.loggerStoreName, 'readonly')
        const store = trans.objectStore(conf.loggerStoreName)
        const getReq = store.get(0)

        getReq.onsuccess = (event) => {
          console.log('getReq.onsuccess', event.target.result)
          if (event.target.result === undefined) {
            resolve([])
            return
          }
          resolve(event.target.result.logs)
        }
      }
    })
  }

  /**
   * 引数のログ情報をindexedDBに保存する
   * @param {Object} logs 保存ログ情報
   * @private
   */
  _updateLogs (logs) {
    const openReq = indexedDB.open(conf.defaultDBName)
    openReq.onsuccess = (event) => {
      const db = event.target.result
      const trans = db.transaction(conf.loggerStoreName, 'readwrite')
      const store = trans.objectStore(conf.loggerStoreName)
      const getReq = store.put({ id: 0, logs: logs })

      getReq.onsuccess = (event) => {
        console.log(event.target.result)
      }
    }
  }
}
